module.exports = __webpack_public_path__ + "static/img/member_bg.7ee545b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/member_bg.png
// module id = Gpya
// module chunks = 12